import { faArrowLeft, faChevronRight, faHome } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { withTranslation } from 'react-i18next';

import Action from '../../Action';
import Button from '../Button';
import ButtonsContainer from '../ButtonsContainer';

import * as style from './style.module.css';

const BreadcrumbActions = ({ actions }) => {
  if (actions?.length === 0) {
    return null;
  }

  return <div className={`${style.actions}`} key={actions.map(e => e.label).join('-')}>
    <ButtonsContainer scrollable={false} noMargin>
      {actions.map((action, i) => (
        <Button key={i} action={action.action} icon={action.icon} label={action.label} loading={action.loading || false} disabled={action.disabled || false} theme="PRIMARY" iconOnlyOnMobile active/>
      ))}
    </ButtonsContainer>
  </div>
}

const Breadcrumb = ({ history = [], includeRoot = true, actions = [], t }) => {
  const computedHistory = [...(includeRoot ? [{ icon: faHome, title: t('Home'), action: '/', isRoot: true, }] : []), ...history];
  const previous = computedHistory[computedHistory.length - 2] || null;

  return (
    <div className={`${style.breadcrumbContainer}`}>
      <div className={style.breadcrumb}>
        {previous && <Button label={t('Back')} className={style.previous} action={previous.action} icon={faArrowLeft} iconOnlyOnMobile />}

        {computedHistory.map((e, i) => (
          <React.Fragment key={i}>
            {i > 0 && <FontAwesomeIcon className={`${style.separator} ${i === 1 ? style.firstSeparator : ''}`} icon={faChevronRight} />}
            <Action title={e.title} action={e.action} className={`${style.element} ${i === computedHistory.length - 1 ? style.current : ''} ${e.isRoot ? style.root : ''}`}>
              {e.icon && <FontAwesomeIcon icon={e.icon} className={`${style.icon} ${e.title ? style.hasText : ''}`} />}
              {e.title || null}
            </Action>
          </React.Fragment>
        ))}
      </div>
      <BreadcrumbActions actions={actions} t={t} />
    </div>
  );
};

export default withTranslation()(Breadcrumb);
